import React, { useEffect, useState } from "react";
import leftArrow from "../../../assets/Images/left-arrow.png";
import rightArrow from "../../../assets/Images/right-arrow.png";
import { DPR_API } from "../../../services/apiCalls/dprApiCalls";

import "react-responsive-modal/styles.css";

export default function MachineryList({ subId }) {
  const [machnery, setMachinery] = useState([]);
  const getMachneryBySub = async (id) => {
    const manP = await DPR_API.get_resource_machinerybysubId(id);
    if (manP && manP.resources?.length) {
      setMachinery(manP.resources);
    }
  };

  useEffect(() => {
    getMachneryBySub(subId);
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(machnery.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = machnery.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <React.Fragment>
      <div className="table-container" style={{width:'100%'}}>
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Sr No </th>
              <th>Machinery</th>
              <th>No of Machinery</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  {row.Machinary}
                </td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  <span className="no-of-resource">{row.No_Of_Machinery}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, machnery.length)} to{" "}
            {Math.min(currentPage * rowsPerPage, machnery.length)} of{" "}
            {machnery.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            {/* Left Arrow */}
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow} // Replace with your actual image path
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            {/* Right Arrow */}
            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow} // Replace with your actual image path
                alt="Next"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
              />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
